import React from 'react';
import styled from 'styled-components';

import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

//import './index.scss';

type HandicapProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const Handicap = (componentProps: HandicapProps) => {
  let props = componentProps;
  let isVisible = true;

  const dataElementContext = React.useContext(DataElementContext);
  [props, isVisible] = processComponentProps(props, dataElementContext);
  const [state, setState] = React.useState({
    types: [
      { label: 'Main', value: 'main' },
      { label: 'All', value: 'all' },
    ],
    selectedType: 'main',
  });

  const onSetType = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    const tab = event.currentTarget.getAttribute('data-tab');
    if (['main', 'all'].includes(tab || '')) {
      setState((prevState) => ({
        ...prevState,
        selectedType: tab || '',
      }));
    }
    event.stopPropagation();
  }, []);

  const mainHeader = React.useCallback(
    (market: any) => {
      if (!market) return [];
      const columns: any[] = [];

      if (dataElementContext?.parentContext?.match) {
        columns.push({
          label: dataElementContext.parentContext.match.team1Name,
          value: 'home',
        });

        columns.push({
          label: dataElementContext.parentContext.match.team2Name,
          value: 'away',
        });
      }

      return columns;
    },
    [dataElementContext],
  );
  const mainOutcomes = React.useCallback((market: any) => {
    if (!market) return [];
    const outcomesMap: any = {
      home: [],
      away: [],
    };

    market.outcomes?.forEach((outcome: any) => {
      let oddName = (outcome.nameWithoutArgument?.[2] ?? outcome.nameWithoutArgument?.[0] ?? '').toLowerCase();
      oddName = oddName.replace('+', '');

      if (oddName === 'handicap 1' || oddName === 'h1') {
        outcomesMap['home'].push(outcome);
      } else if (oddName === 'handicap 2' || oddName === 'h2') {
        outcomesMap['away'].push(outcome);
      }
    });

    const outcomesList: any[] = [];

    const maxLength = Math.max(outcomesMap['home'].length, outcomesMap['away'].length);

    for (let i = 0; i < maxLength; i++) {
      const rowOutcomes: any[] = [];
      ['home', 'away'].forEach((side) => {
        if (outcomesMap[side][i]) {
          rowOutcomes.push(outcomesMap[side][i]);
        } else {
          rowOutcomes.push({ label: ' ' });
        }
      });
      outcomesList.push({ outcomes: rowOutcomes });
    }

    return outcomesList;
  }, []);

  const contextValue = React.useMemo(() => {
    const market = props.properties.market;

    return {
      market,
      mainHeader: mainHeader(market),
      mainOutcomes: mainOutcomes(market),
      actions: {
        onSetType,
      },
      ...state,
    };
  }, [props, state, mainHeader, mainOutcomes, onSetType]);

  if (!isVisible) return null;
  //console.log('Handicap[contextValue]', contextValue);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default Handicap;
